import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  id: "tabGeneral",
  style: {"display":"none"}
}
const _hoisted_2 = {
  id: "tabAccount",
  style: {"display":"none"}
}
const _hoisted_3 = {
  id: "tabPrice",
  style: {"display":"none"}
}
const _hoisted_4 = {
  id: "tabAddress",
  style: {"display":"none"}
}

import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, reactive, ref,} from "vue";
import {RouteLocationNormalizedLoaded, useRoute, useRouter} from "vue-router";
import {useNavigationStore} from "@/modules/Navigation/store";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import Person from "@/shared/model/person";
import {SelectEventArgs, TabComponent, TabItemDirective, TabItemsDirective} from "@syncfusion/ej2-vue-navigations";
import PersonComponent from "@/modules/OrganisationStructure/components/PersonCardComponent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import Account from "@/shared/model/Account";
import AccountComponent from "@/modules/OrganisationStructure/components/AccountComponent.vue";
import {useAccountStore} from "@/stores/accountStore";
import {Action} from "@/shared/model/Action";
import PermissionComponent from "@/modules/OrganisationStructure/components/PermissionComponent.vue";
import PriceListComponent from "@/modules/OrganisationStructure/components/PriceListComponent.vue";
import getGuid from "@/shared/utils/getGuid";
import ProductPrice from "@/shared/model/productPrice";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import notificationService from "@/shared/services/NotificationService";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import PersonAcountingComponent from "@/modules/OrganisationStructure/components/PersonAcountingComponent.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonAccountingFormComponent
  from "@/modules/OrganisationStructure/components/PersonAccountingFormComponent.vue";
import {useOrganisationStructureStore} from "@/modules/OrganisationStructure/store";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {useDisplay} from "vuetify";
import SogCardActionMoreButton, {IActionItem} from "@/shared/ui/SogCardActionMoreButton.vue";
import {mdiAccountGroup} from "@mdi/js";
import {useSpinner} from "@/shared/composables/SogSpinner";
import Address from "@/shared/model/Address";
import PersonDetailsId from "@/shared/model/personDetailsId";
import AddressCardComponent from "@/modules/OrganisationStructure/components/AddressCardComponent.vue";
import PersonBankverbindungComponent
  from "@/modules/OrganisationStructure/components/PersonBankverbindungComponent.vue";
import PersonBankverbindungFormComponent
  from "@/modules/OrganisationStructure/components/PersonBankverbindungFormComponent.vue";
import {computed} from "vue";
import PersonEditComponent from "@/modules/OrganisationStructure/components/PersonEditComponent.vue";
import AddressEditComponent from "@/modules/OrganisationStructure/components/AddressEditComponent.vue";
import PersonEvbActivationComponent from "@/modules/OrganisationStructure/components/PersonEvbActivationComponent.vue";
import PersonEvbActivationFormComponent
  from "@/modules/OrganisationStructure/components/PersonEvbActivationFormComponent.vue";
import PersonStatusCardComponent from "@/modules/OrganisationStructure/components/PersonStatusCardComponent.vue";
import ExternalInterfaceCardComponent from "@/modules/OrganisationStructure/components/ExternalInterfaceCardComponent.vue";
import ExportFormulareComponent from "@/modules/OrganisationStructure/components/ExportFormulareComponent.vue";
import ExportFormulareEditComponent from "@/modules/OrganisationStructure/components/ExportFormulareEditComponent.vue";
import RegistrationOfficeComponent from "@/modules/OrganisationStructure/components/RegistrationOfficeComponent.vue";
import RegistrationOfficeEditComponent from "@/modules/OrganisationStructure/components/RegistrationOfficeEditComponent.vue";
import RegistrationInquiryTemplatesComponent from "@/modules/OrganisationStructure/components/RegistrationInquiryTemplatesComponent.vue";

const _tabIndexAddress = 1;
const _tabIndexPurchasePrice = 2;
const _tabIndexSalePrice = 3;
const _tabIndexUser = 4;

export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsPage',
  setup(__props) {

const _tab = ref<InstanceType<typeof TabComponent> | null>(null)
const _accountingForm = ref<InstanceType<typeof PersonAccountingFormComponent> | null>(null)
const _addressForm = ref<InstanceType<typeof AddressEditComponent> | null>(null)
const _bankForm = ref<InstanceType<typeof PersonBankverbindungFormComponent> | null>(null)
const _personForm = ref<InstanceType<typeof PersonEditComponent> | null>(null)
const _evbForm = ref<InstanceType<typeof PersonEvbActivationFormComponent> | null>(null)
const _ExportFormulareForm = ref<InstanceType<typeof ExportFormulareEditComponent> | null>(null)
const _registrationOfficeForm = ref<InstanceType<typeof RegistrationOfficeEditComponent> | null>(null)

const _navigationStore = useNavigationStore();
const _accountStore = useAccountStore();
const _organisationStructureStore = useOrganisationStructureStore();
const _spinner = useSpinner()

const _person = ref<Person>(new Person())
const _account = ref<Account>(new Account())
const _actions = reactive<string[]>([])
const _prices = reactive<ProductPrice[]>([])
const _isAccountingVisible = ref(false)
const _details = ref<PersonDetails>(new PersonDetails(""))
const _editDetails = ref<PersonDetails>(new PersonDetails(""))
const _addresses = reactive<Address[]>([])
const _onEditAddress = ref(false)
const _onAddAddress = ref(false)
const _bankEdit = ref(false)
const _eVbActivationEdit = ref(false)
const _exportFormulareEdit = ref(false)
const _registrationOfficeEdit = ref(false)
const _hasExportBlankProduct = ref<boolean>(false)


const _accountingEdit = ref(false)
const _personEdit = ref(false)
const _tab1Header = {text: "Allgemein"}
const _tab2Header = {text: "Adressen"}
const _tab3Header = {text: "Einkaufspreise"}
const _tab4Header = {text: "Verkaufspreise"}
const _tab5Header = {text: "Benutzer"}

const _tabs = [{index: 0, hide: false}, {index: 1, hide: false}, {index: 2, hide: false}, {
  index: 3,
  hide: false
}, {index: 4, hide: false}]
const _currentTabIndex = ref(0)

const _selectedPrice = ref<ProductPrice | undefined>(undefined)

const _router = useRouter()
const _route = useRoute();


const {width} = useDisplay()

const _isAccountManage = ref(false);
const _isOrganisationStructureManage = ref(false)
const _isPriceManage = ref(false);
const _level = ref("first")

const _actionItems: IActionItem[] = [
  {id: "order", text: "Bestellungen", visible: false},
  {id: "invoice", text: "Rechnungen", visible: false},
  {id: "insurance", text: "Versicherungskarten", visible: false,},
  {id: "employees", text: "Mitarbeiter", visible: false, svgIcon: mdiAccountGroup, mdiIcon: "mdi-account-group"},
]

const _moreActions = ref<IActionItem[]>([])

const _isEditProductPriceVisible = computed(() => {
  if (_person.value.isSupplier()) {
    return _selectedPrice.value
  }
  return (_person.value.isBranch() || _person.value.isCustomer()|| _person.value.isBranchTemplate()) && _selectedPrice.value;
})

const _isDeleteProductPriceVisible = computed(() => {
  return (_person.value.isBranch() || _person.value.isCustomer()|| _person.value.isBranchTemplate()) && _selectedPrice.value;
})

const _isExportFormulareVisible = computed(() => {
  return (_person.value.isBranch() || (_person.value.isCustomer() && _hasExportBlankProduct.value)) || _person.value.isBranchTemplate();
})

async function p_init(route: RouteLocationNormalizedLoaded) {

  _spinner.show()
  try {
    const level = (route.params.level as (string));

    _level.value = level === "" ? "first" : level


    _isAccountManage.value = _accountStore.hasAction(Action.AccountManage)
    _isOrganisationStructureManage.value = _accountStore.hasAction(Action.OrganisationStructureManage)
    _isPriceManage.value = _accountStore.hasAction(Action.ProductPriceManage)
    const id = _navigationStore.currentPersonId
    if (!id) {
      await _router.push("/organisationstructure/list/all")
      return
    }
    const resp = await apiOrganisationStructure.loadPerson(id, _accountStore.person?.id);
    if (resp?.person) {
      _person.value = resp.person
      _details.value = resp.details
      _hasExportBlankProduct.value = resp.hasExportBlankProduct ?? false

      _addresses.length = 0
      //_addresses.push(..._addresses);
      _addresses.push(...resp.addresses)


      _isAccountManage.value &&= (_person.value?.personType === "Natural" || _accountStore.actionPerson?.id === "person_getmann" || (_person.value.isBranch()))

      _tabs[_tabIndexUser].hide = !_isAccountManage.value || _person.value.isBranchTemplate()
      _tabs[_tabIndexPurchasePrice].hide = !_isPriceManage.value || _person.value.isEmployee()
      _tabs[_tabIndexAddress].hide = _person.value.isBranchTemplate();
      _tabs[_tabIndexSalePrice].hide = !_isPriceManage.value || !(_person.value.isCustomer() || _person.value.isBranch()|| _person.value.isBranchTemplate())
      _tabs[_tabIndexPurchasePrice].hide = !_isPriceManage.value || !(_person.value.isSupplier() || _person.value.isManufacturer())

      _tab.value?.hideTab(_tabIndexUser, _tabs[_tabIndexUser].hide)
      _tab.value?.hideTab(_tabIndexPurchasePrice, _tabs[_tabIndexPurchasePrice].hide)

      _tab.value?.hideTab(_tabIndexAddress, _tabs[_tabIndexAddress].hide)
      _tab.value?.hideTab(_tabIndexSalePrice, _tabs[_tabIndexSalePrice].hide)
      _tab.value?.hideTab(_tabIndexPurchasePrice, _tabs[_tabIndexPurchasePrice].hide)

      // TODO: abhängig von  evtl. Lizense auch für kunde sichtbar machen
      _isAccountingVisible.value = (_person.value.isCustomer() || _person.value.isBranch())

      if (_tabs[_organisationStructureStore.detailsPage.currentTabIndex].hide) {
        _organisationStructureStore.detailsPage.currentTabIndex = 0;
      }
      _tab.value?.select(_organisationStructureStore.detailsPage.currentTabIndex)

      _actionItems[0].visible = _person.value.isCustomer() || _person.value.isBranch();
      _actionItems[1].visible = _person.value.isCustomer();
      _actionItems[2].visible = _person.value.isCustomer() || _person.value.isBranch();
      _actionItems[3].visible = _isOrganisationStructureManage.value && (_person.value.isCustomer() || _person.value.isBranch());

      _moreActions.value = _actionItems.filter(t => t.visible)


    } else {
      _spinner.hide()
      await _router.back()
      return
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  const route = useRoute();
  await p_init(route)
})


async function loadAccount() {
  _spinner.show()
  try {
    const id = _navigationStore.currentPersonId ?? "person_agent22"
    const resp = await apiOrganisationStructure.loadAccount(id);
    if (resp) {
      _account.value = resp;
      _actions.length = 0;
      _actions.push(..._account.value.actions ?? [])
      _account.value.actionPersonId = _person.value.id
      if (_level.value === "second") {
        _account.value.personId = _organisationStructureStore.detailsPage.ownerPersonId
      } else if (_person.value.clusterTypes.some(t => t === "employee")) {
        _account.value.personId = _accountStore.person?.id
      } else {//if (_person.value.clusterTypes.some(t => t === "customer" || t === "branch")) {
        _account.value.personId = _person.value.id
      }
    }
  } finally {
    _spinner.hide()
  }
}

async function loadPrice(purchase: boolean) {
  _spinner.show()
  try {
    _prices.length = 0;
    _selectedPrice.value = undefined

    const prices: ProductPrice[] = []
    if (purchase) {
      const key = getGuid();
      const id = _accountStore.person?.id ?? "";
      const res = await apiOrganisationStructure.loadProductPrice(key, id, true)
      if (res?.prices && res?.key === key) {
        if (_person.value.isSupplier()) {
          prices.push(...res.prices.filter(t => t.supplierId === _person.value.id))
        } else if (_person.value.isManufacturer()) {
          prices.push(...res.prices.filter(t => t.manufacturerId === _person.value.id))
        }
      }
    } else {
      const key = getGuid();
      const id = _person.value.id ?? "";
      const res = await apiOrganisationStructure.loadProductPrice(key, id, true)
      if (res?.prices && res?.key === key) {
        prices.push(...res.prices)
      }
    }
    _prices.push(...prices.sort((a, b) => {
      const diff = a?.getSortIndex() - b?.getSortIndex();
      if (diff) return diff;
      return a.productName?.localeCompare(b.productName ?? "") ?? 0;
    }))
  } finally {
    _spinner.hide()
  }
}


async function tabSelected(args: SelectEventArgs) {
  await selectTab(args?.selectedIndex ?? 0);
  _organisationStructureStore.detailsPage.currentTabIndex = args?.selectedIndex ?? 0;
}

async function selectTab(index: number) {
  _currentTabIndex.value = index;
  switch (index) {
    case _tabIndexUser:
      await loadAccount();
      break;
    case _tabIndexPurchasePrice:
      await loadPrice(true);
      break;
    case _tabIndexSalePrice:
      await loadPrice(false);
      break;
  }
}

async function onAddPrice() {
  _organisationStructureStore.productPriceEditPage.person = _person.value
  _organisationStructureStore.productPriceEditPage.productPrices = _prices;
  _organisationStructureStore.productPriceEditPage.price = undefined;
  const type = _currentTabIndex.value === _tabIndexSalePrice ? "sale" : "purchase"
  await _router.push("/organisationstructure/price/add/" + type)
}

async function onEditPrice(price?: ProductPrice) {
  if (!price)
    return
  _organisationStructureStore.productPriceEditPage.person = _person.value
  _organisationStructureStore.productPriceEditPage.price = price;
  _organisationStructureStore.productPriceEditPage.productPrices = undefined;
  const type = _currentTabIndex.value === _tabIndexSalePrice ? "sale" : "purchase"
  await _router.push("/organisationstructure/price/edit/" + type)
}


function onSelectedPrice(price?: ProductPrice) {
  _selectedPrice.value = price
}

const _selectedAddress = ref(new Address())

function onEdit(address: Address) {
  if (!address)
    return
  _onEditAddress.value = true;
  _selectedAddress.value = address
}

function onDeletePrice() {
  if (!_selectedPrice.value)
    return

  notificationService.showYesNo("Wollen Sie löschen", "", async () => {
    try {
      _spinner.show()
      const res = await apiOrganisationStructure.updateDetailsPrice(_accountStore.person?.id, _person.value?.id, undefined, undefined, _selectedPrice.value?.id)
      if (res) {
        await selectTab(_currentTabIndex.value)
      }
    } finally {
      _spinner.hide()
    }

  })
}

function onAccountChanged() {
  selectTab(_tabIndexUser)
}

async function onSaveAccounting() {
  if (!_accountingForm.value.validate())
    return
  try {
    _spinner.show()
    if (!_accountingForm.value)
      return
    const details = _accountingForm.value.getDetails()

    const res = await apiOrganisationStructure.updateDetails(_accountStore.person?.id, _person.value?.id, details.getValues())
    if (res) {
      _accountingEdit.value = false
      await p_init(_route)
    }
  } finally {
    _spinner.hide()
  }
}


async function onSaveBank() {
  if (!_bankForm.value.validate())
    return
  try {
    _spinner.show()
    if (!_bankForm.value)
      return
    const detailsBank = _bankForm.value.getDetailsBank()

    const res = await apiOrganisationStructure.updateDetails(_accountStore.person?.id, _person.value?.id, detailsBank.getValues())
    if (res) {
      _bankEdit.value = false
      await p_init(_route)
    }
  } finally {
    _spinner.hide()
  }
}

async function onSaveEvbActivation() {
  if (!_evbForm.value.validate())
    return
  try {
    _spinner.show()
    if (!_evbForm.value)
      return
    const details = _evbForm.value.getDetails()

    const res = await apiOrganisationStructure.updateDetails(_accountStore.person?.id, _person.value?.id, details.getValues())
    if (res) {
      _eVbActivationEdit.value = false
      await p_init(_route)
    }
  } finally {
    _spinner.hide()
  }
}

async function onSaveExportFormulare() {
  if (!_ExportFormulareForm.value.validate())
    return
  try {
    _spinner.show()
    if (!_ExportFormulareForm.value)
      return
    const details = _ExportFormulareForm.value.getDetails()

    const res = await apiOrganisationStructure.updateDetails(_accountStore.person?.id, _person.value?.id, details.getValues())
    if (res) {
      _exportFormulareEdit.value = false
      await p_init(_route)
    }
  } finally {
    _spinner.hide()
  }
}

async function onSaveRegistrationOffice() {
  if (!_registrationOfficeForm.value?.validate())
    return
  try {
    _spinner.show()
    const details = _registrationOfficeForm.value.getDetails()
    if (!details)
      return

    const res = await apiOrganisationStructure.updateDetails(_accountStore.person?.id, _person.value?.id, details.getValues())
    if (res) {
      _registrationOfficeEdit.value = false
      await p_init(_route)
    }
  } finally {
    _spinner.hide()
  }
}

async function onFinishPersonStatusSave(successful: boolean) {
  if(successful) {
    await p_init(_route)
  }
  _spinner.hide()
}

function onSavePersonStatus() {
  _spinner.show()
}


async function onSavePerson() {
  if (!_personForm.value.validate())
    return
  try {

    _spinner.show()
    if (!_personForm.value)
      return

    const person = _personForm.value.getPerson()

    const res = await apiOrganisationStructure.update(_accountStore.person?.id ?? "", person)
    if (res) {
      _personEdit.value = false;
      await p_init(_route)
    }
  } finally {
    _spinner.hide()
  }
}

function onDeleteAddress(address: Address) {
  if (!address)
    return
  _selectedAddress.value = address
  notificationService.showYesNo("Wollen Diese Addresse löschen", "", async () => {
    try {
      _spinner.show()
      const res = await apiOrganisationStructure.deleteAddress(address?.id ?? "")
      if (res) {
        await p_init(_route)
      }
    } finally {
      _spinner.hide()
    }

  })
}

function onAddAddress() {
  _onAddAddress.value = true;
  _selectedAddress.value = Address.createAddress()

}

async function onCancel() {
  _personEdit.value = false;
  _onEditAddress.value = false;
  _onAddAddress.value = false;
  _bankEdit.value = false;
  _eVbActivationEdit.value = false;
  _exportFormulareEdit.value = false
  _registrationOfficeEdit.value = false
  await p_init(_route)
}

async function onSaveAddress() {
  if (!_addressForm.value.validate())
    return
  try {
    _spinner.show()
    if (!_addressForm.value)
      return
    const address = _addressForm.value.getAddress()

    const res = await apiOrganisationStructure.update(_person.value?.id ?? "", _person.value, address)
    if (res) {
      _onEditAddress.value = false
      _onAddAddress.value = false
      await p_init(_route)
    }
  } finally {
    _spinner.hide()
  }
}


function onShowInsurance() {
  if (_navigationStore.currentPersonId && (_person.value.isBranch() || _person.value.isCustomer())) {
    _router.push("/insurance/list/person")
  }
}

function onShowOrder() {
  if (_navigationStore.currentPersonId && (_person.value.isBranch() || _person.value.isCustomer())) {
    _router.push("/order/sale/list/Order/person")
  }
}

function onShowInvoice() {
  if (_navigationStore.currentPersonId && (_person.value.isCustomer())) {
    _router.push("/order/sale/list/Invoice/person")
  }
}

async function onMoreSelect(id: string) {
  switch (id) {
    case "order" :
      onShowOrder();
      break;
    case "invoice" :
      onShowInvoice();
      break;
    case "insurance" :
      onShowInsurance();
      break;
    case "employees":
      _organisationStructureStore.listPage.secondCurrentPersonId = _navigationStore.currentPersonId ?? "";
      _organisationStructureStore.listPage.secondCurrentPersonName = _navigationStore.currentPersonName ?? "";
      await _router.push("/organisationstructure/list/employee/second");
      break
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _person.value.personName
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_moreActions.value, (item, index) => {
                return _withDirectives((_openBlock(), _createBlock(SogCardActionButton, {
                  key: item,
                  "mdi-icon": item.mdiIcon,
                  onClick: ($event: any) => (onMoreSelect(item.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.text), 1)
                  ]),
                  _: 2
                }, 1032, ["mdi-icon", "onClick"])), [
                  [_vShow, (index+1)*200<_unref(width)]
                ])
              }), 128)),
              _withDirectives(_createVNode(SogCardActionMoreButton, {
                items: _actionItems,
                onSelect: onMoreSelect
              }, null, 512), [
                [_vShow, _actionItems.some(t=>t.visible)]
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(_unref(TabComponent), {
                id: "tab",
                ref_key: "_tab",
                ref: _tab,
                selected: tabSelected
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TabItemsDirective), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabItemDirective), {
                        header: _tab1Header,
                        content: "#tabGeneral"
                      }),
                      _createVNode(_unref(TabItemDirective), {
                        header: _tab2Header,
                        content: "#tabAddress"
                      }),
                      _createVNode(_unref(TabItemDirective), {
                        header: _tab3Header,
                        content: "#tabPrice"
                      }),
                      _createVNode(_unref(TabItemDirective), {
                        header: _tab4Header,
                        content: "#tabPrice"
                      }),
                      _createVNode(_unref(TabItemDirective), {
                        header: _tab5Header,
                        content: "#tabAccount"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SogFlexRow, { style: {"align-items":"stretch","justify-content":"stretch"} }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(PersonComponent, { person: _person.value }, {
                      default: _withCtx(() => [
                        _createVNode(SogCardActions, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-pencil",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_personEdit.value = true))
                            }, null, 512), [
                              [_vShow, !_personEdit.value && !_person.value.isBranchTemplate()]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["person"]), [
                      [_vShow, !_personEdit.value]
                    ]),
                    _withDirectives(_createVNode(SogCard, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardContent, null, {
                          default: _withCtx(() => [
                            _createVNode(PersonEditComponent, {
                              ref_key: "_personForm",
                              ref: _personForm,
                              person: _person.value
                            }, null, 8, ["person"])
                          ]),
                          _: 1
                        }),
                        _createVNode(SogCardActions, null, {
                          default: _withCtx(() => [
                            _createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-content-save",
                              onClick: onSavePerson
                            }),
                            _createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-cancel",
                              onClick: onCancel
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _personEdit.value]
                    ]),
                    _withDirectives(_createVNode(SogCard, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardTitle, null, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode(" Abrechnung/Bestellung ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(SogCardContent, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(PersonAcountingComponent, { details: _details.value }, null, 8, ["details"]), [
                              [_vShow, !_accountingEdit.value]
                            ]),
                            _withDirectives(_createVNode(PersonAccountingFormComponent, {
                              ref_key: "_accountingForm",
                              ref: _accountingForm,
                              details: _details.value
                            }, null, 8, ["details"]), [
                              [_vShow, _accountingEdit.value]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(SogCardActions, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-pencil",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_accountingEdit.value = true))
                            }, null, 512), [
                              [_vShow, !_accountingEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-content-save",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (onSaveAccounting()))
                            }, null, 512), [
                              [_vShow, _accountingEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-cancel",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_accountingEdit.value = false))
                            }, null, 512), [
                              [_vShow, _accountingEdit.value]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _isAccountingVisible.value]
                    ]),
                    _withDirectives(_createVNode(SogCard, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardTitle, null, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode(" Bankverbindung ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(SogCardContent, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(PersonBankverbindungComponent, { details: _details.value }, null, 8, ["details"]), [
                              [_vShow, !_bankEdit.value]
                            ]),
                            _withDirectives(_createVNode(PersonBankverbindungFormComponent, {
                              ref_key: "_bankForm",
                              ref: _bankForm,
                              details: _details.value
                            }, null, 8, ["details"]), [
                              [_vShow, _bankEdit.value]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(SogCardActions, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-pencil",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_bankEdit.value = true))
                            }, null, 512), [
                              [_vShow, !_bankEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-content-save",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (onSaveBank()))
                            }, null, 512), [
                              [_vShow, _bankEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-cancel",
                              onClick: onCancel
                            }, null, 512), [
                              [_vShow, _bankEdit.value]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, !_person.value.isBranchTemplate()]
                    ]),
                    _createVNode(SogCard, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardTitle, null, {
                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                            _createTextVNode(" eVb Generierung ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(SogCardContent, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(PersonEvbActivationComponent, {
                              details: _details.value,
                              person: _person.value
                            }, null, 8, ["details", "person"]), [
                              [_vShow, !_eVbActivationEdit.value]
                            ]),
                            _withDirectives(_createVNode(PersonEvbActivationFormComponent, {
                              ref_key: "_evbForm",
                              ref: _evbForm,
                              details: _details.value,
                              person: _person.value
                            }, null, 8, ["details", "person"]), [
                              [_vShow, _eVbActivationEdit.value]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(SogCardActions, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-pencil",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_eVbActivationEdit.value = true))
                            }, null, 512), [
                              [_vShow, !_eVbActivationEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-content-save",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (onSaveEvbActivation()))
                            }, null, 512), [
                              [_vShow, _eVbActivationEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-cancel",
                              onClick: onCancel
                            }, null, 512), [
                              [_vShow, _eVbActivationEdit.value]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_person.value.isCustomer())
                      ? (_openBlock(), _createBlock(PersonStatusCardComponent, {
                          key: 0,
                          details: (_details.value as PersonDetails),
                          person: _person.value,
                          onOnSaveClick: onSavePersonStatus,
                          onOnFinishEdit: onFinishPersonStatusSave
                        }, null, 8, ["details", "person"]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode(ExternalInterfaceCardComponent, { details: _details.value }, null, 8, ["details"]), [
                      [_vShow, _details.value.getValues().ExternalInterface]
                    ]),
                    _withDirectives(_createVNode(SogCard, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardTitle, null, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode(" Export Formulare ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(SogCardContent, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(ExportFormulareComponent, {
                              details: _details.value,
                              person: _person.value
                            }, null, 8, ["details", "person"]), [
                              [_vShow, !_exportFormulareEdit.value]
                            ]),
                            _withDirectives(_createVNode(ExportFormulareEditComponent, {
                              ref_key: "_ExportFormulareForm",
                              ref: _ExportFormulareForm,
                              details: _details.value,
                              person: _person.value
                            }, null, 8, ["details", "person"]), [
                              [_vShow, _exportFormulareEdit.value]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(SogCardActions, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-pencil",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_exportFormulareEdit.value = true))
                            }, null, 512), [
                              [_vShow, !_exportFormulareEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-content-save",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (onSaveExportFormulare()))
                            }, null, 512), [
                              [_vShow, _exportFormulareEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-cancel",
                              onClick: onCancel
                            }, null, 512), [
                              [_vShow, _exportFormulareEdit.value]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _isExportFormulareVisible.value]
                    ]),
                    _withDirectives(_createVNode(SogCard, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardTitle, null, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode(" Zulassungsstelle ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(SogCardContent, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(RegistrationOfficeComponent, { details: _details.value }, null, 8, ["details"]), [
                              [_vShow, !_registrationOfficeEdit.value]
                            ]),
                            _withDirectives(_createVNode(RegistrationOfficeEditComponent, {
                              ref_key: "_registrationOfficeForm",
                              ref: _registrationOfficeForm,
                              details: _details.value
                            }, null, 8, ["details"]), [
                              [_vShow, _registrationOfficeEdit.value]
                            ])
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(SogCardActions, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-pencil",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_registrationOfficeEdit.value = true))
                            }, null, 512), [
                              [_vShow, !_registrationOfficeEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-content-save",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (onSaveRegistrationOffice()))
                            }, null, 512), [
                              [_vShow, _registrationOfficeEdit.value]
                            ]),
                            _withDirectives(_createVNode(SogCardActionButton, {
                              "mdi-icon": "mdi-cancel",
                              onClick: onCancel
                            }, null, 512), [
                              [_vShow, _registrationOfficeEdit.value]
                            ])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _isOrganisationStructureManage.value]
                        ])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _person.value.isRegistrationOffice()]
                    ]),
                    (_person.value.isManufacturer() && _unref(_accountStore).isRoot)
                      ? (_openBlock(), _createBlock(RegistrationInquiryTemplatesComponent, {
                          key: 1,
                          "insurer-id": _person.value.id ?? ''
                        }, null, 8, ["insurer-id"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(SogFlexRow, null, {
                  default: _withCtx(() => [
                    _createVNode(AccountComponent, {
                      account: _account.value,
                      person: _person.value,
                      changed: onAccountChanged
                    }, null, 8, ["account", "person"]),
                    _withDirectives(_createVNode(PermissionComponent, {
                      "person-id": _account.value.actionPersonId,
                      actions: _actions
                    }, null, 8, ["person-id", "actions"]), [
                      [_vShow, _account.value.loginName]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(SogCard, null, {
                  default: _withCtx(() => [
                    _createVNode(SogCardActions, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-plus",
                          tooltip: "Neue Preis hinzufügen",
                          onClick: onAddPrice
                        }, null, 512), [
                          [_vShow, _person.value.isBranch()||_person.value.isCustomer()||_person.value.isBranchTemplate()]
                        ]),
                        _withDirectives(_createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-pencil",
                          tooltip: "Preis ändern",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (onEditPrice(_selectedPrice.value)))
                        }, null, 512), [
                          [_vShow, _isEditProductPriceVisible.value]
                        ]),
                        _withDirectives(_createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-delete",
                          tooltip: "Preis löschen",
                          onClick: onDeletePrice
                        }, null, 512), [
                          [_vShow, _isDeleteProductPriceVisible.value]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(SogCardContent, null, {
                      default: _withCtx(() => [
                        _createVNode(PriceListComponent, {
                          prices: _prices,
                          "allow-select": "true",
                          selected: onSelectedPrice
                        }, null, 8, ["prices"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createVNode(SogCard, null, {
                  default: _withCtx(() => [
                    _createVNode(SogCardActions, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-plus",
                          tooltip: "Neue Adresse hinzufügen",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (onAddAddress()))
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(SogCardContent, null, {
                      default: _withCtx(() => [
                        _createVNode(SogFlexRow, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_addresses, (_address) => {
                              return (_openBlock(), _createBlock(AddressCardComponent, {
                                key: _address.id,
                                address: _address
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(SogCardActions, null, {
                                    default: _withCtx(() => [
                                      _createVNode(SogCardActionButton, {
                                        "mdi-icon": "mdi-pencil",
                                        onClick: ($event: any) => (onEdit(_address))
                                      }, null, 8, ["onClick"]),
                                      _createVNode(SogCardActionButton, {
                                        "mdi-icon": "mdi-delete",
                                        onClick: ($event: any) => (onDeleteAddress(_address))
                                      }, null, 8, ["onClick"]),
                                      _withDirectives(_createVNode(SogCardActionButton, {
                                        "mdi-icon": "mdi-receipt-text",
                                        disabled: "true",
                                        tooltip: "Rechnungsadresse"
                                      }, null, 512), [
                                        [_vShow, _address.id === _details.value.getValue(_unref(PersonDetailsId).InvoiceAddressId) ?? '']
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["address"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !(_onEditAddress.value || _onAddAddress.value)]
                ]),
                _withDirectives(_createVNode(SogCard, null, {
                  default: _withCtx(() => [
                    _createVNode(SogCardContent, null, {
                      default: _withCtx(() => [
                        _createVNode(AddressEditComponent, {
                          ref_key: "_addressForm",
                          ref: _addressForm,
                          address: _selectedAddress.value,
                          "show-full-name": true
                        }, null, 8, ["address"])
                      ]),
                      _: 1
                    }),
                    _createVNode(SogCardActions, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-content-save",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (onSaveAddress()))
                        }),
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-cancel",
                          onClick: onCancel
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _onEditAddress.value || _onAddAddress.value]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})